/** AI text is plain text, never trusted editor HTML. Signature is the existing agency template. */
export const emailDraftHtml = (text: string, signature = '') => {
  const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r\n?/g, '\n').replace(/\n/g, '<br/>');
  return `<p>${escaped}</p>${signature ? `<br/>${signature}` : ''}`;
};
